import Base64 from './Base64';
import Str from './Str';

class StorageHelper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static saveTempData(value: any) {
    if (typeof value !== 'object') throw new Error('invalid temp data type');
    const tempDataKey = Str.randomAlphaNumericStr(10);
    const str = Base64.encode(JSON.stringify(value));
    localStorage.setItem(tempDataKey, str);
    return tempDataKey;
  }

  static loadTempData(key: string) {
    const b64Str = localStorage.getItem(key);
    if (!b64Str) return null;

    const obj = JSON.parse(Base64.decode(b64Str));
    if (typeof obj !== 'object') return null;

    return obj;
  }

  static removeTempData(key: string) {
    localStorage.removeItem(key);
  }
}
export default StorageHelper;
